module.exports = __webpack_public_path__ + "static/media/logo.66e46cc0.svg";